export default __webpack_public_path__ + "static/media/view-icon.3563cbd3.svg";